import _ from 'lodash'

export function hasPermission(path, componentOperation, operator) {
    return _.indexOf(componentOperation[path], operator) > -1;
}
